<template>
  <b-row class="rules">
    <!-- REMOVER -->
    <button
      v-if="order > 0"
      class="rules--remove-btn"
      @click="$emit('delete', order)"
    >
      <Icon icon="x-icon" />
    </button>

    <!-- DIAS DA SEMANA -->
    <b-col
      :class="{
        'col__size-full': formMultiline,
        col__nopadd: formMultiline,
        'col-12': formMultiline
      }"
      class="col__size"
    >
      <PmwFormSelect
        v-model="value.selectedWeekDays"
        :options="weekDaysOptions"
        :class="{
          col__size: formMultiline,
          col__gutters: formMultiline,
          col__nomargin: formMultiline
        }"
        :showAllOptionsSelectedText="weekDaysOptions.length === 7"
        label="Dias da semana"
        placeholder="Selecione o dia"
        multiple
        class="pax-values--currency lb-form-field"
      >
        <template v-if="weekDaysOptions.length === 0">
          <p class="select__warning">
            Os dias da semana <strong>não</strong> podem ser repetidos entre as
            regras de um mesmo quarto.
          </p>
        </template>
      </PmwFormSelect>
    </b-col>

    <template v-if="typeUpdate == 1">
      <!-- PAX -->
      <b-col
        v-for="(pax, i) in adults"
        :key="`hotel-pax-${roomCode}-${pax}`"
        class="col__size"
      >
        <PmwFormInput
          v-only-numbers
          v-model="value[`pax${i + 1}`]"
          :name="`pax${i + 1}`"
          :label="`${pax} Pax`"
          sufix="Pontos"
          placeholder="00"
          class="pax-values--currency lb-form-field"
        />
      </b-col>

      <!-- CRIANÇAS -->
      <b-col
        v-for="(child, i) in children"
        :key="`hotel-criancas-${roomCode}-${child}`"
        class="col__size"
      >
        <PmwFormInput
          v-model="value[`criancas${i + 1}`]"
          :name="`criancas${i + 1}`"
          :label="`${$options.filters.pluralizer(child, 'Criança | Crianças')}`"
          sufix="Pontos"
          placeholder="00"
          class="pax-values--currency lb-form-field"
        />
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import OnlyNumbersDirective from '@/directives/OnlyNumbersDirective'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'

export default {
  name: 'RoomCardRule',
  directives: {
    'only-numbers': OnlyNumbersDirective
  },
  components: {
    PmwFormSelect,
    PmwFormInput
  },
  props: {
    /** Código do quarto */
    roomCode: {
      type: [Number, String],
      required: true
    },

    /** Tipo de atualização */
    typeUpdate: {
      type: Number,
      default: 1
    },

    /** Dias da semana disponíveis */
    weekDaysOptions: {
      type: Array,
      default: () => []
    },

    /** Quantidade de adultos */
    adults: {
      type: [Number, String],
      default: 1
    },

    /** Quantidade de crianças */
    children: {
      type: [Number, String],
      default: 0
    },

    /** Objeto com as regras selecionadas atualmente */
    value: {
      type: Object,
      default: () => []
    },

    /** Ordem em que se encontra na listagem */
    order: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /**
     * Verifica se a quantidade de campos do form gerará uma nova linha de campos
     * @return {Boolean} true: se tiver mais de 1 linha
     */
    formMultiline() {
      return +this.adults + this.children > 4
    },
    ...mapGetters('hotel', ['getCurrency'])
  },
  watch: {
    /** Escuta mudanças no dia da semana selecionado */
    typeUpdate() {
      /** Zerar o desconto */
      this.value['desconto'] = null
      /** Zerar os valores pax */
      for (let i = 1; i <= this.adults; i++) {
        this.value['pax' + i] = null
      }
      for (let i = 1; i <= this.children; i++) {
        this.value['criancas' + i] = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.col {
  &__size {
    max-width: calc(100% / 5);
    min-width: calc(100% / 5);
    margin-bottom: 35px;

    &-full {
      max-width: 100%;
      width: 100%;
    }
  }

  &__gutters {
    padding-left: 10px;
    padding-right: 10px;
  }

  &__nopadd {
    padding: 0;
  }

  &__nomargin {
    margin: 0;
  }
}

.rules {
  position: relative;

  &--remove-btn {
    @include reset-button();
    position: absolute;
    top: 12px;
    right: 12px;

    .icon {
      width: 12px;
      height: 12px;
      color: $gray-dark;
    }
  }
}

.select {
  &__warning {
    padding: 0 15px;
    line-height: 16px;
    font-size: font-size('size-x-small');
    color: $primary;
  }
}

.pax-values {
  bottom: 10px;

  &--currency {
    ::v-deep {
      .pmw-form-field--label {
        font-weight: font-weight(weight-medium);
      }

      .pmw-label {
        width: calc(100% - 15px);
        max-width: 450px;
        line-height: 21px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .pmw-label__placeholder {
        color: pmw-colors('grey-70');
      }

      .pmw-input__focus {
        border-bottom-color: pmw-colors('blue-100');
      }

      .pmw-select--button,
      .pmw-input--field {
        padding: 8px 8px 11px 2px;
      }

      .pmw-select--button__caret-sort-up {
        border-bottom: 5px solid pmw-colors(blue-100);
      }

      .pmw-select--button:focus {
        border-color: pmw-colors(blue-100);
      }

      .pmw-input {
        background-color: $pmw-white;
      }

      .pmw-form-field--label {
        line-height: font-size('size-large');
        margin-bottom: 0px;
      }

      .pmw-currency-input--clear {
        margin-top: 5px;
        margin-left: 1px;
      }

      .pmw-currency-input--field {
        height: 35px;
      }

      .pmw-form-field--asterisk {
        margin-left: 6px;
      }
    }
  }
}
</style>
